// @flow

import type {Action} from '../../types'
import type {HospitalState} from '../types'
import type {SetCitiesPayload} from '../actions/setCities'

export function setCitiesReducer(state: HospitalState, action: Action<SetCitiesPayload>): HospitalState {

  return {
    ...state,
    cities: action.payload.cities
  }
}
